import { render, staticRenderFns } from "./StockOnHandItemReportData.vue?vue&type=template&id=2e590104"
import script from "./StockOnHandItemReportData.vue?vue&type=script&lang=js"
export * from "./StockOnHandItemReportData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports